import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const errorIcon = cn(shared.iconSm, "shrink-0");

const rememberRow = cn(shared.rowBetween, "text-sm");

const forgotLink = "text-primary hover:underline";

const registrationBadge = "flex justify-center mt-4";

const rememberLabel = cn(shared.rowGap2, "text-sm text-muted-foreground cursor-pointer");

const rememberInput = "h-4 w-4 rounded border-border text-primary focus:ring-ring focus:ring-offset-0 cursor-pointer";

const cardHeader = "pb-2";

export { errorIcon, rememberRow, forgotLink, registrationBadge, rememberLabel, rememberInput, cardHeader };
